export enum KeyboardKeys {
  ArrowDown = 40,
  ArrowUp = 38,
  ArrowLeft = 37,
  ArrowRight = 39,
  Space = 32,
  R = 82,
  C = 67
}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/common/KeyboardKeys.ts